import { ParcellaGiudiziale } from 'src/app/common/models/parcella-giudiziale';
import { ParcellaSoggetto } from 'src/app/common/models/parcella-soggetto';
import { ParcellaStragiudiziale } from 'src/app/common/models/parcella-stragiudiziale';
import { ParcellaStragiudizialeAdapter } from '../parcelle-stragiudiziali-edit/parcella-stragiudiziale-adapter';

export class ParcellaSoggettoAdapter {
  parcellaSoggetto: ParcellaSoggetto = new ParcellaSoggetto();
  constructor(parcellaSoggetto: ParcellaSoggetto, parcella: ParcellaStragiudiziale | ParcellaGiudiziale) {
    this.parcellaSoggetto.id = parcellaSoggetto.id ? parcellaSoggetto.id : null;
    this.parcellaSoggetto.soggetto = parcellaSoggetto.soggetto  ?  JSON.parse(JSON.stringify(parcellaSoggetto.soggetto)) : null;
    this.parcellaSoggetto.percentualeParcella = parcellaSoggetto.percentualeParcella ? parcellaSoggetto.percentualeParcella : null;
    this.parcellaSoggetto.parcella = parcella  ?  this.removeCircularStructure(parcella) : null;
  };

  removeCircularStructure(parcella: ParcellaStragiudiziale | ParcellaGiudiziale): ParcellaStragiudiziale | ParcellaGiudiziale {
    let newParcella = new ParcellaStragiudizialeAdapter(parcella).parcellaStragiudiziale;
    delete newParcella.parcelleSoggetti;
    return newParcella;
  }

}
